/* FV - 2026-05-19 - Funzione riutilizzabile: trasforma ogni <select class="sp-multiline-select">
 * in un widget Select2 con opzioni a due righe (titolo + meta).
 *
 * Markup atteso per ogni <option>:
 *   - testo visibile         = riga 1 (titolo)
 *   - attributo data-meta    = riga 2 (sottotitolo)
 *
 * Esempio:
 *   <select class="sp-multiline-select form-select form-select-sm">
 *       <option value="1" data-meta="Eseguita: 15/05/2026 - 8 volte">Ricerca Commesse</option>
 *   </select>
 *
 * IMPORTANTE: NON aggiungere la classe Bootstrap "w-100" al <select> server-side.
 *   Select2 nasconde l'<select> originale con .select2-hidden-accessible (width:1px !important),
 *   ma .w-100 nella cascata Pyxis vince e il select resta dimensionato come il container,
 *   sommando altezza al wrapper Select2 -> scroll Y indesiderato della pagina.
 *   Il widget e' gia' allargato al 100% via opzione select2({ width: '100%' }) qui sotto.
 *
 * API:
 *   SPMultilineSelect.apply(scope)   -> scope opzionale (jQuery o DOM); default = document
 *
 * Re-init automatico:
 *   - su DOM ready
 *   - dopo ogni partial postback ASP.NET WebForms (UpdatePanel) via Sys.WebForms.PageRequestManager
 */
(function ($) {
    'use strict';
    if (!$ || !$.fn || !$.fn.select2) { return; }

    function formatOption(state) {
        if (!state.id) { return state.text; }
        var $opt = $(state.element);
        var meta = $opt.attr('data-meta') || '';
        var $row = $('<div class="sp-multiline-option"></div>');
        $row.append($('<div class="sp-multiline-option-title"></div>').text(state.text));
        if (meta) {
            $row.append($('<div class="sp-multiline-option-meta blockquote-footer"></div>').text(meta));
        }
        return $row;
    }

    function formatSelection(state) {
        if (!state.id) { return state.text; }
        return state.text;
    }

    function applyToSelect($el) {
        if ($el.hasClass('select2-hidden-accessible')) {
            $el.select2('destroy');
            $el.off('select2:open.spmultiline');
            $el.off('select2:closing.spmultiline');
        }
        // FV - 2026-05-21 - modalita' "sempre aperto" (data-always-open="true"): il dropdown viene renderizzato
        // inline nel parent del <select>, aperto al load, e la sua chiusura e' bloccata finche' non c'e' una selezione concreta.
        // La .select2-selection (pillola chiusa "Seleziona...") viene nascosta via CSS (vedi audirevi-custom.css).
        var alwaysOpen = $el.attr('data-always-open') === 'true';
        var dropdownParent;
        if (alwaysOpen) {
            dropdownParent = $el.parent();
        } else {
            dropdownParent = $el.closest('.modal').length ? $el.closest('.modal') : $(document.body);
        }
        var placeholder = $el.attr('data-placeholder') || $el.find('option[value=""]').first().text() || '';
        var searchPlaceholder = $el.attr('data-search-placeholder') || 'Cerca...';

        $el.select2({
            theme: 'bootstrap-5',
            width: '100%',
            dropdownParent: dropdownParent,
            placeholder: placeholder,
            allowClear: $el.data('allow-clear') === true,
            // FV - 2026-05-20 - NON usare 'dropdownCssClass': nella build select2.min.js del bundle gulp manca il modulo compat/dropdownCss
            // (l'opzione genera "Error: No select2/compat/dropdownCss" e aborta l'init). Aggiungiamo la classe via select2:open qui sotto.
            templateResult: formatOption,
            templateSelection: formatSelection
        });

        // Applica .sp-multiline-select-dropdown al dropdown overlay ad ogni apertura
        // e imposta il placeholder dell'input di ricerca (attributo HTML, non gestibile da CSS).
        $el.on('select2:open.spmultiline', function () {
            var $dropdown = $('.select2-container--open .select2-dropdown');
            $dropdown.addClass('sp-multiline-select-dropdown');
            $dropdown.find('.select2-search__field').attr('placeholder', searchPlaceholder);
        });

        if (alwaysOpen) {
            // Apre il dropdown subito dopo l'init
            setTimeout(function () { $el.select2('open'); }, 0);
            // Blocca la chiusura finche' non c'e' una selezione valida (diversa da "" / "-1")
            $el.on('select2:closing.spmultiline', function (e) {
                var val = ($el.val() || '').toString();
                if (val === '' || val === '-1') { e.preventDefault(); }
            });
        }
    }

    window.SPMultilineSelect = {
        apply: function (scope) {
            var $scope = (scope && scope.jquery) ? scope : $(scope || document);
            $scope.find('select.sp-multiline-select').each(function () {
                try { applyToSelect($(this)); } catch (e) { if (window.console) { console.warn('SPMultilineSelect: init failed', e); } }
            });
        }
    };

    function init() { window.SPMultilineSelect.apply(document); }

    $(document).ready(init);

    if (typeof Sys !== 'undefined' && Sys.WebForms && Sys.WebForms.PageRequestManager) {
        Sys.WebForms.PageRequestManager.getInstance().add_endRequest(init);
    }
})(window.jQuery);
